import { Session } from './Session';

export interface Pass {
  passId: string;
  passName: string;
  numberOfPassesLeft: number;
  numberOfPassesSold: number;
  price: number;
  customFields: {
    ti8m_passtype: {
      Id: string,
      KeyAttributes: [],
      LogicalName: string,
      Name: string
    }
  };
  currencySymbol: currencySymbol;
  passesUsed: number;
  sessions: Session[];
}

export function getCurrencyCode(symbol: currencySymbol): string {
  switch (symbol) {
    case currencySymbol.CHF:
      return 'CHF';
    case currencySymbol.USD:
      return 'USD';
  }
}

export enum currencySymbol {
  CHF = 'Fr.',
  USD = '$'
}
